module.exports = {
  "country": "IE",
  "artist": "Johnny Logan",
  "song": "Hold me now",
  "year": "1987",
  "place": "1",
  "spotify": "7KG1uA3O9cqahhVt5atWnB"
};